import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { AccordionContentBlock, PlainContentModuleContainer } from "@silvertours/front-entities";
export var Faq = function(props) {
    var content = props.content, translations = props.translations;
    var accordion = content.map(function(param) {
        var answer = param.answer, question = param.question, image = param.image;
        return {
            prompt: question,
            content: answer,
            image: image
        };
    });
    return /*#__PURE__*/ _jsx(PlainContentModuleContainer, {
        children: /*#__PURE__*/ _jsx(AccordionContentBlock, {
            content: _object_spread_props(_object_spread({}, props), {
                accordion: accordion
            }),
            rules: {
                badge: {
                    style: "orange"
                }
            },
            translations: translations
        })
    });
};
